import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyDifferent } from './components/WhyDifferent';
import { WhatYouCanDo } from './components/WhatYouCanDo';
import { Author } from './components/Author';
import { Showcase } from './components/Showcase';
import { Testimonials } from './components/Testimonials';
import { IsItForYou } from './components/IsItForYou';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Guarantee } from './components/Guarantee';
import { FinalOffer } from './components/FinalOffer';
import { FAQ } from './components/FAQ';
import { Final } from './components/Final';
import { Button } from './components/Button';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-dark text-white selection:bg-brand-yellow selection:text-black" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <WhyDifferent data-id="element-4" />
        <WhatYouCanDo data-id="element-5" />
        <Author data-id="element-6" />
        <Showcase data-id="element-7" />
        <Testimonials data-id="element-8" />
        <IsItForYou data-id="element-9" />
        <Modules data-id="element-10" />
        <Bonuses data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FinalOffer data-id="element-13" />
        <FAQ data-id="element-14" />
        <Final data-id="element-15" />
      </main>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 w-full p-4 bg-brand-dark/95 backdrop-blur-md border-t border-white/10 z-50 md:hidden flex items-center justify-between gap-4" data-id="element-16">
        <div className="flex flex-col" data-id="element-17">
          <span className="text-xs text-gray-400 font-bold uppercase" data-id="element-18">
            Oferta hoy
          </span>
          <span className="text-brand-yellow font-display text-xl" data-id="element-19">
            $19.999
          </span>
        </div>
        <Button className="py-3 px-6 text-sm flex-1" data-id="element-20">ACCEDER AHORA</Button>
      </div>

      {/* Footer */}
      <footer className="py-8 text-center text-gray-500 text-sm border-t border-white/5 pb-24 md:pb-8" data-id="element-21">
        <p data-id="element-22">
          © {new Date().getFullYear()} Sistema Microcemento Rentable. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs opacity-60" data-id="element-23">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </footer>
    </div>;
}